import { render, staticRenderFns } from "./popup-ling-liao.vue?vue&type=template&id=cb2bfabc&scoped=true"
import script from "./popup-ling-liao.vue?vue&type=script&lang=js"
export * from "./popup-ling-liao.vue?vue&type=script&lang=js"
import style0 from "./popup-ling-liao.vue?vue&type=style&index=0&id=cb2bfabc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2bfabc",
  null
  
)

export default component.exports